import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { useSearchParams } from "react-router-dom";
import SwitchTab from "../../components/Reusable/SwitchTab";

const PartySummaryComponent = loadable(
  () => import("../../components/GeneralLegder/PartySummary")
);

export default () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabs = [
    {
      id: "ledger-account",
      label: "Account",
      href: "/accounting/general-ledger-account",
    },
    {
      id: "ledger-party",
      label: "Party",
      href: "/accounting/general-ledger-party",
    },
    {
      id: "party-summary",
      label: " Party Summary",
      href: "/accounting/general-ledger-party-summary",
    },
  ];
  return (
    <>
      <SwitchTab tabs={tabs} />
      <PartySummaryComponent />
    </>
  );
};

